import type { FC } from "react";

const HoverComponent: FC = () => (
  <div className="pointer-events-none absolute inset-0 z-3 flex h-full w-full items-center justify-center bg-black/60 opacity-0 transition group-hover:opacity-90">
    <div className="flex h-12 w-12 items-center justify-center rounded-full bg-white/50 mix-blend-normal backdrop-blur-sm">
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="white"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path d="M4 3.5L16 10L4 16.5V3.5Z" />
      </svg>
    </div>
  </div>
);

export default HoverComponent;
